/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import './Cabecera.css';

const Cabecera = ({ currentPoints, totalPoints, faltas, homeClickHandler }) => (
    <>
        <div className="return">
            <img src={`${process.env.PUBLIC_URL}/img/home.png`} alt="home" className="home__img" onClick={homeClickHandler} />
        </div>
        <div className="current-points">{currentPoints}</div>
        <div className="cabecera__right">
            <div className="total-points">
                <div className="total-points__number">{totalPoints}</div>
                <img src={`${process.env.PUBLIC_URL}/img/coins.png`} alt="coins" className="total-points__img" />
            </div>
            <div className="faltas">
                <div className="faltas_number">{faltas}</div>
                <img src={`${process.env.PUBLIC_URL}/img/faltas.png`} alt="alert" className="faltas__img" />
            </div>
        </div>
    </>
);

export default Cabecera;
